import { render } from "./HelpComponent.vue?vue&type=template&id=1d64252c&scoped=true"
import script from "./HelpComponent.vue?vue&type=script&lang=js"
export * from "./HelpComponent.vue?vue&type=script&lang=js"

import "./HelpComponent.vue?vue&type=style&index=0&id=1d64252c&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d64252c"]])

export default __exports__